"use client";

import { ChevronDown } from "lucide-react";
import { useState, ReactNode } from "react";

interface NavDropdownProps {
  label: string;
  children: ReactNode;
  className?: string;
}

export default function NavDropdown({
  label,
  children,
  className = "",
}: Readonly<NavDropdownProps>) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={`relative ${className}`}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <button
        type="button"
        className={`
          flex items-center gap-1.5 text-base font-bold  py-2 px-1 text-ordianry 
          hover:text-primary transition-colors
        `}
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
      >
        {label}
        <ChevronDown
          size={16}
          className={`transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>

      {/* Dropdown Content */}
      <div
        className={`
          absolute top-full right-0 pt-2 z-50
          transition-all duration-200 origin-top-right
          ${
            isOpen
              ? "opacity-100 scale-100 pointer-events-auto"
              : "opacity-0 scale-95 pointer-events-none"
          }
        `}
      >
        <div
          className="
          bg-white rounded-xl shadow-xl border border-gray-200/80
          py-2 min-w-55 text-right overflow-hidden
        "
        >
          {children}
        </div>
      </div>
    </div>
  );
}
